import { getSiteEmbedIifePreviewUrl } from "../get-site-embed-iife-url";

import type { LangType, SiteEmbedVariant } from "./types";

/** iframe 内スクリプトと親の `postMessage` 判定で共通利用 */
export const SITE_EMBED_PREVIEW_ERROR_MESSAGE_TYPE = "chillnn-site-embed-preview-error";

export function escapeHtmlAttr(value: string): string {
	return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/**
 * app/frontend/site-embed と同様、script は site-id とマウント先は各要素の data 属性で指定する。
 */
export function getPreviewMountHtml(variant: SiteEmbedVariant): string {
	switch (variant) {
		case "button":
			return `<button data-chillnn-reservation-button-trigger style="cursor:pointer;border-radius:8px;border:0;padding:10px 20px;font-size:14px;font-weight:600;color:#fff;background:#0f172a;">
  予約する
</button>`;
		case "form":
			return `<div data-chillnn-reservation-form></div>`;
		case "calendar":
			return `<div data-chillnn-reservation-calendar></div>`;
	}
}

export type BuildSiteEmbedPreviewHtmlParams = {
	hotelID: string;
	variant: SiteEmbedVariant;
	lang: LangType;
	/**
	 * true のとき `data-chillnn-preview-skip-payjp="true"` を付与し Pay.js はスタブのみ（iframe プレビュー向け）。
	 * false のとき本番に近く CDN から Pay.js を読む。
	 */
	skipPayjp: boolean;
};

/**
 * サイト埋め込み管理画面プレビュー用の単一 HTML 文書（blob URL または document.write 用）。
 */
export function buildSiteEmbedPreviewHtml(params: BuildSiteEmbedPreviewHtmlParams): string {
	const { hotelID, variant, lang, skipPayjp } = params;
	const scriptSrc = escapeHtmlAttr(getSiteEmbedIifePreviewUrl());
	const siteId = escapeHtmlAttr(hotelID);
	const langAttrLine = lang === "default" ? "" : `  data-chillnn-lang="${escapeHtmlAttr(lang)}"\n`;
	const mountHtml = getPreviewMountHtml(variant);
	const skipPayjpAttr = skipPayjp ? `  data-chillnn-preview-skip-payjp="true"\n` : "";

	const errorBridgeScript = `<script>
(function(){
  var T=${JSON.stringify(SITE_EMBED_PREVIEW_ERROR_MESSAGE_TYPE)};
  function post(msg){
    try{
      if(window.parent&&window.parent!==window){
        window.parent.postMessage({type:T,message:String(msg)},"*");
      }
    }catch(e){}
  }
  window.addEventListener("error",function(e){
    var parts=[];
    if(e.message)parts.push(e.message);
    if(e.filename)parts.push("("+e.filename+":"+(e.lineno||0)+")");
    if(e.error&&e.error.stack)parts.push(e.error.stack);
    if(e.target&&e.target!==window&&e.target!==document){
      var el=e.target;
      if(el.tagName==="SCRIPT"&&el.src)parts.push("script load failed: "+el.src);
    }
    if(parts.length)post(parts.join("\\n"));
  },true);
  window.addEventListener("unhandledrejection",function(e){
    var r=e.reason;
    post(r&&(r.stack||r.message)?(r.stack||r.message):String(r));
  });
})();
</script>`;

	return `<!DOCTYPE html>
<html lang="ja">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
</head>
<body style="margin:0;padding:8px;font-family:system-ui,sans-serif;">
${errorBridgeScript}
${mountHtml}
<script
  src="${scriptSrc}"
  data-chillnn-site-id="${siteId}"
${skipPayjpAttr}${langAttrLine}></script>
</body>
</html>`;
}
